var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "43.2 212.3 505.5 175.3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m148.7 240.8c6.5-8 9.6-18.2 8.7-28.4-10 1-19.3 5.8-25.9 13.4-6.6 7.4-10 17.1-9.3 27 10.1.4 20-4.1 26.5-12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m148.7 240.1c6.3-7.8 9.4-17.8 8.7-27.8-10 1-19.3 5.8-25.9 13.4-6.6 7.4-10 17.1-9.3 27 10.3.3 20.1-4.4 26.5-12.6m8.5 14.3c-14.4-.9-26.7 8.2-33.3 8.2s-17.4-7.8-28.9-7.6c-15.2.4-29 8.9-36.2 22.2-15.6 26.8-4.1 66.8 11.1 88.2 7.3 11.1 16.1 22.2 27.8 22.2s15.3-7.1 28.7-7.1 17.2 7.1 28.9 6.9 19.6-11.1 26.9-21.6c5.2-7.6 9.2-16 12-24.8-14.2-6.3-23.3-20.4-23.2-35.9.2-13.6 7.4-26.2 19-33.3-7.4-10.5-19.3-17-32.1-17.4m113-14.2v27.7h22.2v19.1h-22.2v65c0 10.1 4.4 14.8 14.3 14.8 2.7 0 5.3-.2 8-.6v19c-4.4.8-8.9 1.2-13.4 1.1-23.9 0-33.3-9-33.3-31.8v-67.2h-16.8v-19.4h17.1v-27.7zm103.5 145.8h-25.8l-42.6-118.1h25.8l29.6 94.2 30-94.2h25.3zm174.3-70.8h-47v-47.1h-22.4v47.1h-46.8v22.1h46.8v47.4h22.4v-47.4h47z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleTv);
export default __webpack_public_path__ + "static/media/apple-tv.ebb61c53a918be15695a9b9de6b2ac58.svg";
export { ForwardRef as ReactComponent };